<template>
  <div
    class="box"
    @click="boxUpdateConfig({ item: 'advanced', key: 'view_mode', value: 'automatic' });sidebarChangePanel('themes')">
    <div class="box-image">
      <img src="../../../../assets/img/box-auto.svg" alt="">
    </div>
    <div class="pull-right">
      <div class="box-title">{{ $t('edit.sidebar.auto') }}</div>
      <span class="box-text">{{ $t('edit.sidebar.at_some_point') }}</span>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  methods: mapActions([
    'boxUpdateConfig',
    'sidebarChangePanel',
  ]),
};
</script>



/** WEBPACK FOOTER **
 ** Automatic.vue?c02f516a
 **/